import { Component, OnInit, OnDestroy, AfterViewInit, HostListener, ViewChild, ElementRef,Renderer2 } from '@angular/core';
import { DraftService } from './../resultboard/draft/draft.service';
import { Subscription } from 'rxjs';
import { MainService } from 'src/app/_services/main.service';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd, Event } from '@angular/router';
import { environment } from './../../environments/environment';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ResultboardService } from 'src/app/resultboard/resultboard.service';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
import { MatSnackBar } from '@angular/material';
import { SortablejsOptions } from 'angular-sortablejs';
import { DarkModeAction } from './../store/actions/appActions';
import html2canvas from './../../../node_modules/html2canvas/dist/html2canvas.min.js';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
declare var TextDecoder;
@Component({
  selector: 'app-draft2',
  templateUrl: './draft2.component.html',
  styleUrls: ['./draft2.component.scss'],
  animations: [
    trigger('openSlider', [
      state('open', style({
        height: '{{ adj_height }}'
      }), { params: { 'adj_height': '100px' } }),
      state('close', style({
        height: '0px'
      })),
      state('half', style({
        height: '{{ half_height }}'
      }), { params: { 'half_height': '42px' } }),
      transition('open <=> close', animate('0.5s ease')),
      transition('open <=> half', animate('0.5s ease')),
      transition('close <=> half', animate('0.5s ease')),
    ]),
    trigger('openMessage', [
      state('open', style({
        'height': '40px',
      })),
      state('close', style({
        'height': '0px',
        'border-bottom': '0'
      })),
      transition('open <=> close', animate('0.5s ease'))
    ]),
    trigger('openModal', [
      state('openDesktop', style({
        'opacity': 1
      })),
      state('closeDesktop', style({
        'opacity': 0
      })),
      state('openMobile', style({
        'max-height': '100vh'
      })),
      state('closeMobile', style({
        'max-height': '0vh'
      })),
      transition('openDesktop <=> closeDesktop', animate('0.5s ease')),
      transition('openMobile <=> closeMobile', animate('0.5s ease'))
    ])
  ]
})

@HostListener('scroll', ['$event'])
export class Draft2Component implements OnInit, OnDestroy, AfterViewInit {
  
  @ViewChild("screen") screen: ElementRef;
  @ViewChild("canvas") canvas: ElementRef;
  @ViewChild("downloadLink") downloadLink: ElementRef;

  @ViewChild('sliderContainer') sliderContainer: ElementRef;
  @ViewChild('tContainer') tContainer: ElementRef; // vertical
  @ViewChild('playersTable') playersTable: ElementRef;
  hoverStyle = {
    top: '0px',
    left: '0px',
    display: 'none',
    width: '0px'
  };
  queueOptions: SortablejsOptions = {
    handle: '.dragIcon',
    onUpdate: (event) => {
    },
    onEnd: (event) => {
      if (event['oldIndex'] != event['newIndex']) {
        this.queueDrop(event['oldIndex'], event['newIndex']);
      }
    }
  };
  hoverRoster: any = null;
  hoverRosterPopup: any = null;
  user: any = null;
  isMobile = false;
  positionColors = {};
  isActiveDraft = false;
  currentView = 'slider';
  isAutoPick = false;
  FakeisAutoPick = false;
  browsername='';
  isMac = false;
  scrollUpdating = false;
  clearKeys = false;
  showModal = false;
  tableSort = 'order';
  tableSortOrder = -1;
  showResetIcon = false;
  tableNumRows = 6;
  tableHeaderHeight = 72;
  tableCHeight = `${this.tableHeaderHeight + (this.tableNumRows * 38)}px`; 
  showRankings = false;
  showLoading = true;
  showRoster = {};
  showRosterNew = {};
  currentinfoid:number;
  infoTab = null;
  scoringTab = null;
  showRosterOwner: any = {};
  pickOrder = [];
  roster_removed = [];
  rankingSets = [];
  teams = ['ALL'];
  teamFilter = null;
  searchTimer: any = null;
  prizesExpand = false;
  isMessage = 'open';
  league_id = 0;
  common_rank_id = 0;
  ping_time = 0;
  delta = 0;
  unreadMessages = 0; // used for chat badge
  league_picks = 0; // total picks in the league, calculated
  league_rounds = 0; // total rounds of picks, calculated
  sliderScroll = 0;
  rosterTabIndex = 0;
  pScroll = 0;
  qScroll = 0;
  scrollBarHeight = 0;
  currentPick: any = 1;
  timeleft = 0; // pick time remaining in seconds
  timeleftTimer: any = null;
  pickInfoBox: any = null;
  readyBox: any = null;
  league: any = null;
  filterStyles: any = null;
  search = '';
  players = [];
  tablePlayers: any = [];
  slider = [];
  queue = [];
  queuePlayers = [];
  selectedFilters = [];
  topIndex = 0;
  draftData: any = null;
  sliderState = 'close';
  playerSelecting = false;
  selectedTab = 0; // used for mat-tab index
  filledPosition = {
    'background-color': '#EEE',
    'color': '#000',
    'border': '1px solid transparent'
  };
  playerInfoRef: MatDialogRef<Playerinfobox2Component>;
  reloadConfirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  // subscriptions
  s_pong: Subscription; // pong()
  s_refreshPage: Subscription; // refreshPage()
  s_isMobileScreen: Subscription;
  s_initListener: Subscription;
  s_navigation: Subscription;
  s_activeDraft: Subscription;
  s_listActiveDraft: Subscription; // listActiveDraft()
  s_pickTime: Subscription; // pickTime()
  s_pickChanges: Subscription; // pickChanges()
  s_pickedPlayer: Subscription; // pickedPlayer()
  s_draftCompleted: Subscription; // draftCompleted()
  s_showDraft: Subscription; // showDraftStatus()
  s_draftReset: Subscription; // draftReset()
  s_leaguePost: Subscription; // leaguePost() -- This was made for badge updating even though it'll also be used in chat component
  s_pausedMessage: Subscription; // pausedMessage()
  s_resumeMessage: Subscription; // resumeMessage()
  s_predraft: Subscription; // predraft()
  s_readybox: Subscription; // readybox()
  s_reversePick: Subscription; // no idea
  s_disconnect: Subscription;
  // header links
  leagueURL = '';
  myTeamURL = '';
  matchupURL = '';
  playersURL = '';
  draftURL = '';
  settingsURL = '';
  siteURL = `${environment.SITE_URL}`;
  lobbyURL = `${environment.SITE_URL}/drafts/lobby`;
  bucketURL = `${environment.assetURL}/assets/default/images/`;
  playerURL = `${environment.assetURL}/assets/uploads/players/`;
  // debug
  startTime = 0;
  endTime = 0;
  darkMode= false;
  sub_darkMode:Subscription;
  darkMode_ext = '';
  current_lgm_id:number;
  showCamIcon = true;
  showCanvas = false;
  showLoadingBorder = false;
  disableDraft = false;
  s3url = this.bucketURL+'logo.png';
  imageData = {};
  logoUrl = 'assets/default/images/logo-red.png'
  allImgsArray = [];
  getRosterData = {};
  constructor(private snackBar: MatSnackBar, private store: Store<any>, public dialog: MatDialog, private router: Router, private _draftService: DraftService, private _resultboardService: ResultboardService, private _mainService: MainService, private route: ActivatedRoute) {
    this.scrollBarHeight = this.getScrollbarWidth();
    this.store.select('authData').subscribe(state => {
      if (state[0]) {
        this.user = state[0];
        // start data flow
        if (this.league_id != 0) {
          this.setupSockets();
          this.getDraftData();
        }
      }
    });
    this.s_navigation = router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.showLoading = true;
      }
      if (event instanceof NavigationStart) {
        this.unsubSockets();
        this.showLoading = true;
      }
    });
    if (navigator.appVersion.indexOf("Mac")!=-1) this.isMac =true;
    if (navigator.userAgent.match(/AppleWebKit/) && ! navigator.userAgent.match(/Chrome/)) {
      this.browsername = 'safaribrowser';
   }

    this.route.params.subscribe(params => {
      this.unsubSockets();
      this.hoverStyle = {
        top: '0px',
        left: '0px',
        display: 'none',
        width: '0px'
      };
      this.hoverRoster = null;
      // this.isMessage = 'close';
      this.sliderState = 'close';
      this.infoTab = null;
      this.scoringTab = null;
      this.showLoading = true;
      this.players = [];
      this.tablePlayers = [];
      this.prizesExpand = false;
      this.scrollUpdating = false;
      this.tableCHeight = `${this.tableHeaderHeight + (this.tableNumRows * 38)}px`; 
      this.slider = [];
      this.teams = ['ALL'];
      this.rankingSets = [];
      this.queue = [];
      this.pickOrder = [];
      this.roster_removed = [];
      this.queuePlayers = [];
      this.league_id = params['league_id'];
      this.league = null;
      this.searchTimer = null;
      this.isAutoPick = false;
      this.clearKeys = false;
      this.showModal = false;
      this.showRankings = false;
      this.showRoster = {};
      this.showRosterOwner = {};
      this.selectedFilters = [];
      this.filterStyles = null;
      this.unreadMessages = 0;
      this.selectedTab = 0;
      this.sliderScroll = 0;
      this.qScroll = 0;
      this.pScroll = 0;
      this.topIndex = 0;
      this.rosterTabIndex = 0;
      this.draftData = null;
      this.search = '';
      this.pickInfoBox = null;
      this.disableDraft = false;
      this.teamFilter = null;
      if (this.user != null) {
        this.setupSockets();
        this.getDraftData();
      }
    });

    this.s_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
        if(this.isMobile ){
          this.isMobile = (window.innerWidth < 1000) ?  true : false;
        }
      }
    });
    this.sub_darkMode =  this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
        this.darkMode_ext = this.darkMode?'-dark':'';
        this.logoUrl = this.darkMode?'assets/default/images/logo.png':'assets/default/images/logo-red.png';
        if(this.darkMode){
          this.filledPosition = {
            'background-color': 'var(--bkg-color4)',
            'color': 'var(--text-color4)',
            'border': '1px solid transparent'
          };
        }
       
      }
    });

    let dm = localStorage.getItem('darkMode');
    if(dm=='true' || dm==null){
      this.darkMode = false;
       this.toggleDarkTheme();
    }
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubSockets();
    clearInterval(this.timeleftTimer);
  }

  ngAfterViewInit() {
    this.showLoading = true;
  }

  getDraftData() {
    if (this.league_id != 0) {
      this.startTime = Date.now();
      this._draftService.getDraftData2(this.league_id, this.user.id).subscribe(res => {
        if (res.status != null && res.status == 1) {
          // console.log(res);
          this.league = res.entities.league;
          this.common_rank_id = res.entities.league.common_rank_id;
          this.isAutoPick = (res.entities.apm > 0) ? true : false;
          // console.log(this.league);
          this.draftData = res.entities;
          // console.log(this.draftData);
          if (this.draftData.lgm.length > 4) {
            this.currentView = 'table';
          } else {
            this.currentView = 'slider';
          }
          this.rosterTabIndex = this.draftData.lgm.reduce((acc, lm, index) => {
            if (lm.team_id == this.draftData.myteam_id) acc = index;
            return acc;
          }, 0);
          this.pickInfoBox = res.entities.pick_info_box;
          if(this.pickInfoBox && this.pickInfoBox.status == 1){
            setTimeout(() => {
              if(this.reloadConfirmDialogRef)
              this.reloadConfirmDialogRef.close();
              this.reloadConfirmDialogRef = this.dialog.open(ConfirmboxComponent, {
                  width: '500px',
                  data: { 
                    title : "Refresh Page Alert",
                    body: 'The draft is not full yet. Please check back again when the draft started.',
                    cancelBtn : false
                  }
              });
              this.reloadConfirmDialogRef.afterClosed().subscribe(res => {
                document.location.href = `${environment.SITE_URL}/drafts/lobby`;
              });
            }, 1000);
          }
          if (this.pickInfoBox.status == 4) {
            this.currentView = 'table';
            this.tableCHeight = 'none';
            this.removeAllPositions();
          }
          setTimeout(()=>{
            this.resetTableRowsView()
          },2000)
          // console.log(this.pickInfoBox);
          this.readyBox = res.entities.ready_box;
          this.readyBox.im_ready = false; // update this once we get info from gary
          this.currentPick = this.pickInfoBox.pick_number;
          if (this.pickInfoBox.status == 2 || this.pickInfoBox.status == 4 || this.pickInfoBox.status == 5 || this.league.duration_id == 8) this.isMessage = 'open';
          this.timeleft = Math.round(this.pickInfoBox.timestamp + this.delta - Date.now() / 1000) - 1;
          if (this.pickInfoBox.status == 3 || this.pickInfoBox.status == 2) {
            this.startTimer();
          }
          this.filterStyles = {};
          this.draftData.roster_position.forEach(rp => {
            if (rp.pname == 'All') {
              rp.tpick = (this.league.duration_id != 8) ? this.draftData.roster_position.reduce((acc, r) => { if (r.pname != 'All') acc += r.tpick; return acc; }, 0) : this.league.total_players;
              rp.cpick = this.draftData.roster_position.reduce((acc, r) => acc += r.cpick, 0);
            }
            this.filterStyles[rp.pname] = {
              'color': '#FFF',
              'background-color': this.getRGBAColor(rp.color_code),
              'border': '1px solid '+this.getRGBAColor(rp.color_code),
              'text-shadow': 'none'
            };
            const colorcode = this.getRGBAColor(rp.color_code);
            this.filterStyles[rp.pname + '-off'] = {              
              'color':  (rp.pname == 'All' || rp.pname == 'Hitters') ?'var(--text-color)':colorcode,
              // 'background-color': 'var(--position-default)',
              'border': '1px solid '+this.getRGBAColor(rp.color_code),
              'text-shadow': 'none'
            };
          });
          this.selectedFilters = this.draftData.roster_position.reduce((obj, elm) => {
            obj.push(elm.pname);
            return obj;
          }, []);
          // debug
          // this.currentPick = 14;
          // this.timeleft = 35;
          // this.pickInfoBox.status = 3;
          // end debug
          // set league_picks and league_rounds (use league_rounds for mod to reverse order)
          this.league_picks = (this.league.duration_id != 8) ? this.draftData.roster_position.reduce((acc, r) => { if (r.pname != 'All') acc += r.tpick; return acc; }, 0) * this.draftData.lgm.length : this.league.total_players * this.draftData.lgm.length;
          this.league_rounds = this.league_picks / this.draftData.lgm.length;
          for (let i = 0; i < this.league_rounds; i++) {
            for (let j = 0; j < this.draftData.lgm.length; j++) {
              if (j == 0 && i > 0) this.draftData.lgm.reverse();
              // set up this.slider
              this.slider.push({
                round: i + 1,
                pick: j + 1,
                total_pick: i * this.draftData.lgm.length + (j + 1),
                team_name: this.draftData.lgm[j].drafters_id, // maybe use team_name here if we allow changes
                team_picture: this.draftData.lgm[j].imageUrl,
                image: this.draftData.lgm[j].imageUrl,
                lgm_id: this.draftData.lgm[j].team_id,
                bgColor: 'rgb(80, 219, 13)',
                user_id:this.draftData.lgm[j].user_id
              });
              if (j == this.draftData.lgm.length - 1 && i == this.league_rounds - 1 && i % 2) {
                // last iteration complete, odd final index, swap back to restore order
                this.draftData.lgm.reverse();
              }
            }
          }
          this.setRosterRemoved();
          // console.log('end getDraftData');
          // console.log('call setHeaderLinks');
          this.setHeaderLinks(this.draftData);
          // console.log('call getPlayerPool');
          this.getPlayerPool();
          if(this.league.duration_id == 10){
            this.tableHeaderHeight = 131.5;
            this.tableCHeight = `${this.tableHeaderHeight + (this.tableNumRows * 38)}px`; 
          }
        }
      });
    }
  }

  setupSockets() {
      if (this.s_disconnect) this.s_disconnect.unsubscribe();
      this.s_disconnect = this._resultboardService.disconnectEvent().subscribe(r => {
          this.openSnackBar('Connection Lost, Refreshing...', 'OK');
          setTimeout(() => {
            if(this.reloadConfirmDialogRef)
            this.reloadConfirmDialogRef.close();
            this.reloadConfirmDialogRef = this.dialog.open(ConfirmboxComponent, {
                width: '500px',
                data: { 'title': "Refresh Page Alert",'body': 'Draft has disconnected... please refresh the page.'}
            });
          this.reloadConfirmDialogRef.afterClosed().subscribe(res => {
            document.location.reload();
          });
          }, 2000);
      });
    if (this.s_pong) this.s_pong.unsubscribe();
    this.s_pong = this._resultboardService.pong().subscribe(r => {
      const ts = Date.now();
      const server_time = r.t;
      const transit = (ts - this.ping_time) / 2;
      this.delta = ts - (server_time + transit);
      this.delta /= 1000; // in seconds, not milliseconds
      // console.log('delta', this.delta);
    });
    if (this.s_refreshPage) this.s_refreshPage.unsubscribe();
    this.s_refreshPage = this._resultboardService.refreshPage().subscribe(r => {
      if (r.status == 1) {
        if(this.reloadConfirmDialogRef)
        this.reloadConfirmDialogRef.close();
        this.reloadConfirmDialogRef = this.dialog.open(ConfirmboxComponent, {
            width: '500px',
            data: { 'title': "Refresh Page Alert",'body': 'Draft has disconnected... please refresh the page.'}
        });
      this.reloadConfirmDialogRef.afterClosed().subscribe(res => {
        document.location.reload();
      });      
    }
    });
    if (this.s_initListener) this.s_initListener.unsubscribe();
    this.s_initListener = this._resultboardService.draftAppListener().subscribe(r => {
      this.draftData.position_removed = r.entities.position_removed;
      this.setRosterRemoved();
      this.pickInfoBox = r.entities.pick_info_box;
      if (this.pickInfoBox.status == 4) {
        this.currentView = 'table';
        this.tableCHeight = 'none';
        this.removeAllPositions();
      }
      this.timeleft = Math.round(this.pickInfoBox.timestamp + this.delta - Date.now() / 1000) - 1; // seconds remaining
      this.startTimer();
      r.entities.pick_order.forEach(p => {
        const index = p.pnum - 1;
        if (this.slider[index].player == null) {
          const myPosition = this.draftData.roster_position.filter(rp => rp.pname == p.ppos);
          const myTeamData = this.draftData.lgm.filter(lm => lm.team_id == p.id);
          this.slider[index].player_id = p.player_id;
          this.slider[index].p_pos = (myPosition.length > 0) ? myPosition[0].id : '';
          this.slider[index].owner = (myTeamData.length > 0) ? myTeamData[0].team_name : '';
          this.slider[index].player_picture = p.imageUrl;
          const color = p.color_code;
          const rgbaColor = this.getRGBAColor(color);
          this.slider[index].bgColor = rgbaColor;
          this.slider[index].bye_week = (this.league.duration_id == 8) ? " ("+ this.players[this.slider[index].player_id].bye +")" : "";
          this.slider[index].team = this.players[this.slider[index].player_id].tn.toUpperCase();
          this.slider[index].player = (this.slider[index].p_pos != 16) ? this.players[this.slider[index].player_id].fn.substr(0, 1) + '. ' + this.players[this.slider[index].player_id].ln : this.players[this.slider[index].player_id].fn + ' ' + this.players[this.slider[index].player_id].ln;
          this.slider[index].player_name_full =  this.players[this.slider[index].player_id].fn + ' ' + this.players[this.slider[index].player_id].ln;
          this.players[p.player_id]['own'] = 'yes';

          if (parseInt(p.user_id) == this.user.id) {
            this.updateCPick();
            this.setRosterRemoved();
          }
          this.currentPick = p.pnum + 1;
          if (this.pickInfoBox.status == 3 || this.pickInfoBox.status == 5) {
            // slide to current pick far right, or just 0
            if (this.currentView == 'slider') {
              const sliderRef = this.sliderContainer.nativeElement as HTMLElement;
              sliderRef.scrollLeft = ((this.currentPick - Math.floor(sliderRef.clientWidth / 95) > 0) ? (this.currentPick - Math.floor(sliderRef.clientWidth / 95)) * 95 - 1 : 0);
            } else {
              const tRef = this.tContainer.nativeElement as HTMLElement;
              if(!this.showResetIcon){
                tRef.scrollTop = ((Math.floor((this.currentPick - 1) / this.draftData.lgm.length) - 5) * 40);
                setTimeout(()=>{
                  this.showResetIcon = false;
                },800);
              }
              if (tRef.scrollWidth > tRef.clientWidth) {
                tRef.scrollLeft = (Math.floor((this.currentPick - 1) / this.draftData.lgm.length) % 2) ? 30 + ((this.draftData.lgm.length - ((this.currentPick - 1) % this.draftData.lgm.length)) - 3) * 95 : 30 + ((((this.currentPick - 1) % this.draftData.lgm.length) - 2) * 95);
              }
            }
          }
        }
        if (this.slider != null && this.slider[this.currentPick - 1] != null && this.slider[this.currentPick - 1].lgm_id == this.draftData.myteam_id && this.user.pick_sound) this._resultboardService.playSound();
      });
      this.getPickOrder();
    });
    if (this.s_pickChanges) this.s_pickChanges.unsubscribe();
    this.s_pickChanges = this._resultboardService.pickChanges().subscribe(r => {
      // console.log('s_pickChanges', r);
      if (r.entities != null && this.league != null && parseInt(r.entities.league.id) == this.league.id) {
        this.pickInfoBox = r.entities.pick_info_box;
        if(this.pickInfoBox.is_active==1){
          this.disableDraft=false;
        }
        if (this.pickInfoBox.status == 3) {
          if(this.pickInfoBox.is_active == 1){
            window.document.title = 'Your Pick!';
            this.resetTableRowsView();
          } else if(this.pickInfoBox.message != null){
            window.document.title = this.pickInfoBox.message.replace("turn until your pick", "away");
          }
        } else {
          window.document.title = 'Drafters';
        }

        this.currentPick = this.pickInfoBox.pick_number;
        this.readyBox.message = r.entities.pick_info_box.message;
        // this.checkMissedPicks();
        if (this.pickInfoBox.status == 4) {
          this.currentView = 'table';
          this.tableCHeight = 'none';
          this.removeAllPositions();
          this.isMessage = 'open';
          this.isAutoPick = false;
          this.getTablePlayers();
          this.getQueuePlayers();
          setTimeout(()=>(this.getShowRoster(this.draftData.myteam_id,false,false)),2000);
        } else {
          this.getShowRoster(this.current_lgm_id?this.current_lgm_id:this.draftData.lgm[this.rosterTabIndex].team_id, true);
        }
        this.timeleft = Math.round(this.pickInfoBox.timestamp + this.delta - Date.now() / 1000) - 1; // seconds remaining
        if (this.pickInfoBox.status != 5) {
          this.startTimer();
        } else {
          clearInterval(this.timeleftTimer);
        }
        // if (this.pickInfoBox.status == 3 && this.league.duration_id != 8 && !this.isAutoPick) this.isMessage = 'close';
      }
    });

    if (this.s_listActiveDraft) this.s_listActiveDraft.unsubscribe();
    this.s_listActiveDraft = this._resultboardService.listActiveDraft().subscribe(r => {
      // console.log('s_listActiveDraft',r);
      // remove old players keys by name if they're not in r.entities
      if (!this.clearKeys) {
        const existingDrafts = r.entities.reduce((acc, obj) => {
          acc.push(obj.league_id);
          return acc;
        }, []);
        let existingKeys: any = localStorage.getItem('draft_keys');
        const roster_mt = JSON.parse(localStorage.getItem('roster_mt'));
        let updated_roster_mt : any  = {};
        existingKeys = JSON.parse(existingKeys);
        const existingKeysUnchanged = (existingKeys != null) ? [...existingKeys] : null; //create clone with own property
        if (existingKeysUnchanged != null) {
          existingKeysUnchanged.forEach((k, i) => {
            if (existingDrafts.indexOf(parseInt(k)) == -1 || (existingKeysUnchanged.length > 5 && i < existingKeysUnchanged.length - 5)) {
              // delete players key here
              existingKeys.splice(i, 1);
              localStorage.removeItem('players_' + k);
            } else if(roster_mt != null && roster_mt[k] != null){ 
              updated_roster_mt[k] = roster_mt[k]; /**Refector the updated time */
            }
          });
          try {
            localStorage.setItem('draft_keys', JSON.stringify(existingKeys));
            localStorage.setItem('roster_mt', JSON.stringify(updated_roster_mt));
          } catch (e) {
            // quota
          }
        }
        this.clearKeys = true;
      }
    });

    if (this.s_pickedPlayer) this.s_pickedPlayer.unsubscribe();
    this.s_pickedPlayer = this._resultboardService.pickedPlayer().subscribe(r => {
      if (r.entities != null && this.league != null && parseInt(r.entities.league_id) == this.league.id) {
        if (parseInt(r.entities.picked_player.user_id) == this.user.id) {
          this.isAutoPick = (r.entities.autopickmode == 0) ? false : true;
          if (this.isAutoPick) this.isMessage = 'open';
        }
        const index = r.entities.picked_player.pnum - 1;
        const myTeamData = this.draftData.lgm.filter(lm => lm.team_id == r.entities.picked_player.id);
        this.slider[index].player_id = r.entities.picked_player.player_id;
        this.slider[index].p_pos = r.entities.gp_id;
        this.slider[index].owner = (myTeamData.length > 0) ? myTeamData[0].team_name : '';
        this.slider[index].player_picture = r.entities.picked_player.imageUrl;
        const color = r.entities.picked_player.color_code;
        const rgbaColor = this.getRGBAColor(color);
        this.slider[index].bgColor = rgbaColor;
        this.slider[index].player = (r.entities.gp_id != 16) ? this.players[this.slider[index].player_id].fn.substr(0, 1) + '. ' + this.players[this.slider[index].player_id].ln : this.players[this.slider[index].player_id].fn + ' ' + this.players[this.slider[index].player_id].ln;
        this.slider[index].player_name_full =  this.players[this.slider[index].player_id].fn + ' ' + this.players[this.slider[index].player_id].ln;
        this.slider[index].bye_week = (this.league.duration_id == 8) ? " ("+ this.players[this.slider[index].player_id].bye +")" : "";
        this.slider[index].team = (this.players[this.slider[index].player_id].tn != null) ? this.players[this.slider[index].player_id].tn.toUpperCase() : "";
        this.players[r.entities.picked_player.player_id]['own'] = 'yes';
        if (parseInt(r.entities.picked_player.user_id) == this.user.id) {
          this.draftData.position_removed = r.entities.position_removed;
          this.updateCPick();
          this.setRosterRemoved();
          // this.draftData.roster_position.forEach(rp => {
          //   if (rp.pname == r.entities.picked_player.ppos){
          //     rp.cpick++;
          //   }
          // });
        }
        this.currentPick = r.entities.picked_player.pnum + 1;
        if (this.pickInfoBox.status == 3 || this.pickInfoBox.status == 5) {
          if (this.currentView == 'slider') {
            // slide to current pick far right, or just 0
            const sliderRef = this.sliderContainer.nativeElement as HTMLElement;
            sliderRef.scrollLeft = ((this.currentPick - Math.floor(sliderRef.clientWidth / 95) > 0) ? (this.currentPick - Math.floor(sliderRef.clientWidth / 95)) * 95 - 1 : 0);
          } else {
            const tRef = this.tContainer.nativeElement as HTMLElement;
            if(!this.showResetIcon){
              tRef.scrollTop = ((Math.floor((this.currentPick - 1) / this.draftData.lgm.length) - 5) * 40);
              setTimeout(()=>{
                this.showResetIcon = false;
              },800);
            }
            // console.log(this.draftData.lgm.length - ((this.currentPick - 1) % this.draftData.lgm.length));
            if (tRef.scrollWidth > tRef.clientWidth) {
              tRef.scrollLeft = (Math.floor((this.currentPick - 1) / this.draftData.lgm.length) % 2) ? 30 + ((this.draftData.lgm.length - ((this.currentPick - 1) % this.draftData.lgm.length)) - 3) * 95 : 30 + ((((this.currentPick - 1) % this.draftData.lgm.length) - 2) * 95);
            }
          }
        }
        this.checkMissedPicks(r.entities.picked_player.pnum + 1);
        if (this.slider != null && this.slider[this.currentPick - 1] != null && this.slider[this.currentPick - 1].lgm_id == this.draftData.myteam_id && this.user.pick_sound) this._resultboardService.playSound();
        if (this.pickInfoBox.status == 4) {
          this.currentView = 'table';
          this.tableCHeight = 'none';
          // this.draftCompleted();
          this.isMessage = 'open';
        }
        this.getShowRoster(this.current_lgm_id?this.current_lgm_id:this.draftData.lgm[this.rosterTabIndex].team_id, true);
        this.getTablePlayers();
        this.getQueuePlayers();
        this.getPickOrder();
      }
      if(parseInt(r.entities.picked_player.user_id) == this.user.id){
      this.clearSearch();
      this.clearFilter();
      }
      this.getHoverRoster(r.entities.picked_player.id);
    });
    // if (this.s_draftCompleted) this.s_draftCompleted.unsubscribe();
    // this.s_draftCompleted = this._resultboardService.draftCompleted().subscribe(r => {
    //   // console.log('s_draftCompleted',r);
    //   this.pickInfoBox = r.pick_info_box;
    //   if (this.pickInfoBox.status == 4) this.removeAllPositions();
    //   this.isMessage = 'open';
    //   this.isAutoPick = false;
    //   this.getTablePlayers();
    //   this.getQueuePlayers();
    //   this.getShowRoster(this.draftData.myteam_id);
    // });
    if (this.s_showDraft) this.s_showDraft.unsubscribe();
    this.s_showDraft = this._resultboardService.showDraftStatus().subscribe(r => {
      // console.log('s_showDraft', r);
    });
    if (this.s_draftReset) this.s_draftReset.unsubscribe();
    this.s_draftReset = this._resultboardService.draftReset().subscribe(r => {
      // console.log('s_draftReset',r);
      location.reload(); // refresh if the draft resets
    });
    if (this.s_reversePick) this.s_reversePick.unsubscribe();
    this.s_reversePick = this._resultboardService.lastPickReverse().subscribe(r => {
      // console.log('s_reversePick',r);
      location.reload(); // refresh if reverse picks
    });
    if (this.s_leaguePost) this.s_leaguePost.unsubscribe();
    this.s_leaguePost = this._resultboardService.draftMessage().subscribe(r => {
      // console.log('s_leaguePost',r);
      if (r.entities.feed_type == 'league_message' && this.selectedTab != 2) this.unreadMessages++;
    });
    if (this.s_pausedMessage) this.s_pausedMessage.unsubscribe();
    this.s_pausedMessage = this._resultboardService.pausedMessage().subscribe(r => {
      // console.log('s_pausedMessage',r);
      if (this.league != null && this.league.id != null && r.league_id == this.league.id) {
        this.pickInfoBox.status = 5;
        this.isMessage = 'open';
        clearInterval(this.timeleftTimer);
      }
    });
    if (this.s_resumeMessage) this.s_resumeMessage.unsubscribe();
    this.s_resumeMessage = this._resultboardService.resumeMessage().subscribe(r => {
      // console.log('s_resumeMessage',r);
      if (this.league != null && this.league.id != null && r.league_id == this.league.id) {
        this.pickInfoBox.status = 3;
        // if (this.pickInfoBox.status == 3 && this.league.duration_id != 8 && !this.isAutoPick) this.isMessage = 'close';
        this.pickInfoBox.timestamp = r.timestamp;
        this.timeleft = Math.round(this.pickInfoBox.timestamp + this.delta - Date.now() / 1000) - 1; // seconds remaining
        this.startTimer();
      }
    });
    // obsolete
    // if (this.s_predraft) this.s_predraft.unsubscribe();
    // this.s_predraft = this._resultboardService.predraft().subscribe(r => {
    //   // console.log('s_predraft',r);
    //   this.timeleft = r;
    //   this.pickInfoBox.status = 2;
    //   this.startTimer();
    // });
    if (this.s_readybox) this.s_readybox.unsubscribe();
    this.s_readybox = this._resultboardService.readybox().subscribe(r => {
      // console.log('s_readybox',r);
      if (r.entities.user_id == this.draftData.myteam_id) {
        this.readyBox.im_ready = true;
      }
      this.readyBox.message = r.entities.message;
      this.getPickOrder();
    });
  }

  imReady(event) {
    if (event.checked) {
      this._resultboardService.imReady(this.league.id, this.user.id, this.league.entrants);
      this.readyBox.im_ready = true;
    }
  }

  leaveRoom() {
    if (this.league != null && this.league.id != null) this._resultboardService.leaveRoom(this.league.id);
  }

  socketConnect() {
    this._resultboardService.callDraftApp(this.draftData.myteam_id, this.league.id);
    if (this.s_activeDraft) this.s_activeDraft.unsubscribe();
    this.s_activeDraft = this._resultboardService.activeDraftEmit({
      user_id: this.user.id,
      is_app: 1,
      is_connect: 1
    }).subscribe(res => {
      this.s_activeDraft.unsubscribe();
    });
    // start delta process
    this.ping_time = Date.now();
    this._resultboardService.ping();
  }

  getPlayerPool(overwrite = false) {
    // console.log('getPlayerPool start');
    // check localstorage first, if no key for this league_id+lgm_id combination, hit endpoint
    const localPlayers = localStorage.getItem('players_' + this.league_id);
    let roster_mt = JSON.parse(localStorage.getItem('roster_mt'));
    const cacheExpired = (roster_mt != null && roster_mt[this.league_id] != null && roster_mt[this.league_id] >= this.draftData.last_modify) ? false : true;
    if (localPlayers == null || overwrite || cacheExpired) {
      this._draftService.getPlayerTable(this.league_id, this.league.game_id, this.league.season_id, this.league.event_type_id, this.draftData.myteam_id, 'draft', this.league.egs, this.league.lgs, this.league.duration_id).subscribe(data => {
        // console.log('getPlayerTable service');
        this.players = data.entities.reduce((map, obj, index) => {
          map[parseInt(obj.id)] = obj;
          if (this.league.simple != null && this.league.simple == 'Y' && obj.pn.indexOf(',') > -1) {
            map[parseInt(obj.id)].pn = obj.pn.substr(0, obj.pn.indexOf(','));
          }
          map[parseInt(obj.id)].order = index + 1;
          map[parseInt(obj.id)].id = parseInt(obj.id);
          if (obj.it == null) map[parseInt(obj.id)].it = '';
          if (obj.avg == null && obj.fpts != null && obj.gp != null) map[parseInt(obj.id)].avg = (obj.gp > 0) ? obj.fpts / obj.gp : 0;
          return map;
        }, {});
        // console.log(this.players);
        // store to localStorage if draft isn't done
        try {
          if (this.pickInfoBox.status != 4) {
            // console.log('storing players key localStorage');
            localStorage.setItem('players_' + this.league_id, JSON.stringify(this.players));
            let existingKeys = JSON.parse(localStorage.getItem('draft_keys'));
            if (existingKeys != null) {
              if(existingKeys.indexOf(this.league_id) == -1) {
                existingKeys.push(this.league_id);
                try {
                  localStorage.setItem('draft_keys', JSON.stringify(existingKeys));
                } catch (er) {
                  // quota
                }
              }
            } else {
              existingKeys = [this.league_id];
              try {
                localStorage.setItem('draft_keys', JSON.stringify(existingKeys));
              } catch (er) {
                // quota error
              }
            }

            /**Roster update time caching */
            const last_modify = (this.draftData.last_modify != null) ? this.draftData.last_modify : '0';
            if (roster_mt != null) {
              roster_mt[this.league_id] = last_modify;
              try {
                localStorage.setItem('roster_mt', JSON.stringify(roster_mt));
              } catch (er) {
                // quota
              }
            } else {
              let roster_mt_updated = {};
              roster_mt_updated[this.league_id] = last_modify;
              try {
                localStorage.setItem('roster_mt', JSON.stringify(roster_mt_updated));
              } catch (er) {
                //  
              }
            }
          }
        } catch (e) {
          // quota likely exceeded, user will have to fetch players each time
          // console.log(e);
        }

        // need to get player binary once we switch to new draft players api using redis key
        // if (this.pickInfoBox.status != 4){
        // should do no matter stage of draft, as order is used in infoboxes
        // console.log('call getPlayerBinary');
        // this.getPlayerBinary();
        // } else {
        // console.log('call getSliderData');
        if (!overwrite) {
          this.getSliderData();
        } else {
          // need to update player.own values from existing slider data
          this.slider.forEach(s => {
            if (s.player_id != null) this.players[s.player_id]['own'] = 'yes';
          });
          this.getTablePlayers();
          this.getQueuePlayers();
          this.getPickOrder();
        }
        // }
      });
    } else {
      // console.log('players key already exists');
      // use local players
      this.players = JSON.parse(localPlayers);
      // console.log(this.players);
      // check for player order information, getSliderData if available, else getPlayerBinary()
      if (Object.keys(this.players).filter(id => this.players[id].order != null).length) {// || this.pickInfoBox.status == 4){
        // console.log('order already exists, call getSliderData');
        this.getSliderData();
      } else {
        // console.log('order doesn\'t exist, call getPlayerBinary');
        this.getPlayerBinary();
      }
    }
  }

  getPlayerBinary() {
    // call /getPlayers and update order
    // console.log('getPlayerBinary start');
    this._draftService.getPlayerData(this.league_id, this.league.game_id, this.league.season_id, this.league.event_type_id, this.draftData.myteam_id, 'draft', this.league.egs, this.league.lgs, this.league.duration_id, this.pickInfoBox.status).subscribe(res => {
      // console.log('getPlayerData service');
      res.arrayBuffer().then(buffer => {
        const N = buffer.byteLength / 20; // change this if expanded to queue bitmap
        let order = new Int32Array(buffer, 0, N);
        let col1 = new Float64Array(buffer, N * 4, N);
        let col2 = new Float64Array(buffer, N * 4 + N * 8, N);
        // console.log('getPlayerData N: ' + N);
        order.forEach((o, i) => {
          if (this.players[o] != null) {
            this.players[o].order = i;
            this.players[o][this.draftData.col1.col] = col1[i];
            this.players[o][this.draftData.col2.col] = col2[i];
          }
        });
        // console.log(this.players);
        // save players data with order
        try {
          if (this.pickInfoBox.status != 4) {
            // console.log('store players localStorage key');
            localStorage.setItem('players_' + this.league_id, JSON.stringify(this.players));
          }
        } catch (e) {
          // quota exceeded
        }
        // console.log('call getSliderData');
        this.getSliderData();
      });
    });
  }

  getSliderData() {
    Object.keys(this.players).forEach(pid => {
      if (!this.teams.includes(this.players[pid].tn.toUpperCase())) this.teams.push(this.players[pid].tn.toUpperCase());
    });
    this.teams.sort();
    // console.log('getSliderData start');
    this._draftService.getSliderData(this.league_id).subscribe(res => {
      // console.log('getSliderData service');
      res.arrayBuffer().then(buffer => {
        if (buffer.byteLength > 1) {
          // reconstruct int32array
          // const intView = new DataView(buffer);
          const N = buffer.byteLength / 12;
          let sliderArr = new Int32Array(buffer, 0, N * 3);
          // console.log('getSliderData N: ' + N);
          for (let index = 0; index < N; index++) {
            this.slider[index].lgm_id = sliderArr[index * 3];
            this.slider[index].player_id = sliderArr[index * 3 + 1];
            this.slider[index].p_pos = sliderArr[index * 3 + 2];
          }
          // console.log(this.slider);
          // for (let index=0;index<buffer.byteLength/12;index++){
          //   const player_id = intView.getInt32(index*12 + 4);
          //   this.slider.push({
          //     lgm_id: intView.getInt32(index*12),
          //     player_id,
          //     p_pos: intView.getInt32(index*12 + 8)
          //   });
          //   this.players[player_id].is_picked = 'Y';
          // }
          // add in teams data and player data to slider entries here
          this.slider.forEach((slide, index) => {
            if (this.players[slide.player_id] != null) {
              slide.player = (slide.p_pos != 16) ? this.players[slide.player_id].fn.substr(0, 1) + '. ' + this.players[slide.player_id].ln : this.players[slide.player_id].fn + ' ' + this.players[slide.player_id].ln;
              slide.player_name_full =  this.players[slide.player_id].fn + ' ' + this.players[slide.player_id].ln;
              slide.bye_week = (this.league.duration_id == 8) ? " ("+ this.players[slide.player_id].bye +")" : "";
              slide.team = this.players[slide.player_id].tn.toUpperCase();
              slide.owner = this.draftData.lgm.filter(lm => lm.team_id == slide.lgm_id)[0].team_name;
              slide.player_picture = this.playerURL + this.players[slide.player_id].pp;
              const color = this.draftData.roster_position.filter(rp => rp.id == slide.p_pos)[0].color_code;
              const rgbaColor = this.getRGBAColor(color);
              slide.bgColor = rgbaColor;
              this.players[slide.player_id]['own'] = 'yes';
            }
          });
          // console.log(this.slider);
        }
        // console.log('set currentPick');
        // make sure currentPick value isn't outdated since we called getDraftData
        if (this.slider.filter(s => s.player != null).length + 1 > this.currentPick) {
          this.currentPick = this.slider.filter(s => s.player != null).length + 1;
        }
        if(this.league.duration_id == 10){
          this.draftData.lgm.map((teamData)=>{
            this.getHoverRoster(teamData.team_id);
          });
        }
        // console.log(this.slider);
        this.endTime = Date.now();
        // console.log("Data ready in " + (this.endTime - this.startTime) / 1000 + "s");
        setTimeout(()=>{
          this.showLoading = false;
        },1000)
        setTimeout(() => {
          if (this.pickInfoBox.status == 3 || this.pickInfoBox.status == 5) {
            // console.log('slide to current pick');
            // slide to current pick far right, or just 0
            if (this.currentView == 'slider') {
              const sliderRef = this.sliderContainer.nativeElement as HTMLElement;
              sliderRef.scrollLeft = ((this.currentPick - Math.floor(sliderRef.clientWidth / 95) > 0) ? (this.currentPick - Math.floor(sliderRef.clientWidth / 95)) * 95 - 1 : 0);
            } else {
              const tRef = this.tContainer.nativeElement as HTMLElement;
              if(!this.showResetIcon){
                tRef.scrollTop = ((Math.floor((this.currentPick - 1) / this.draftData.lgm.length) - 5) * 40);
                setTimeout(()=>{
                  this.showResetIcon = false;
                },800);
              }
              if (tRef.scrollWidth > tRef.clientWidth) {
                tRef.scrollLeft = (Math.floor((this.currentPick - 1) / this.draftData.lgm.length) % 2) ? 30 + ((this.draftData.lgm.length - ((this.currentPick - 1) % this.draftData.lgm.length)) - 3) * 95 : 30 + ((((this.currentPick - 1) % this.draftData.lgm.length) - 2) * 95);
              }
            }
          }
        }, 500);
        this.sliderState = 'open';
        // this.getTablePlayers();
        // console.log('call getQueue');
        this.getShowRoster(this.draftData.lgm[this.rosterTabIndex].team_id, true);
        if (this.pickInfoBox.status != 4) {
          // console.log('call socketConnect');
          // we only need the draft socket set up if the draft is still active
          this.socketConnect();
        }
        this.getQueue();
        this.getPickOrder();
      });
    });
  }

  openPlayerInfoBox(player_id, playerList, isDraft, playerData) {
    if (player_id && this.draftData.myteam_id != null && this.draftData.myteam_id > 0) {
      // const draftSelectBox = [];
      // if (this.draftData.myteam_id != null && this.draftData.myteam_id != 0 && this.pickInfoBox.status != 4 && (this.players[player_id].own == null || this.players[player_id].own == 'no')){
      //   // build draftSelectBox of available positions for this player
      //   const player = this.players[player_id];
      //   const eligiblePositions = player.pn.split(',');
      //   this.draftData.roster_position.forEach(rp => {
      //     if (rp.composed_of != null && (this.draftData.position_removed.indexOf(rp.pname) == -1)){
      //       const positions = rp.composed_of.split(',');
      //       for (let i=0;i<positions.length;i++){
      //         if (eligiblePositions.indexOf(positions[i]) > -1){
      //           draftSelectBox.push({
      //             key:rp.pname,
      //             value:rp.display_name
      //           });
      //           break;
      //         }
      //       }
      //     }
      //   });
      // }
      // console.log(draftSelectBox);
      const prevState = this.sliderState;
      const abbr = (typeof (this.league.abbr) !== 'undefined') ? this.league.abbr : 'false';
      this.playerInfoRef = this.dialog.open(Playerinfobox2Component, {
        width: (this.isMobile) ? '90%' : '70%',
        height: 'auto',
        autoFocus: false,
        data: {
          // 'player_id': player_id, 'season_id': String(this.draftData.active_season_id), 'league_id': this.league.id, 'league_team_id': this.draftData.myteam_id,
          // 'abbr': abbr, 'draft_status': this.league.draft_status, 'leagueRecord': this.league.is_paused, 'prePlayer': 0, 'nextPlayer': 0, 'draftSelectBox': draftSelectBox
          isDraft,
          league: this.league,
          lgm_id: this.draftData.myteam_id,
          players: playerList,
          player_id,
          'player_data' : playerData
        }
      });
      this.playerInfoRef.afterOpen().subscribe(res => {
        this.sliderState = prevState;
      });
    }
  }

  getQueue() {
    // console.log('getQueue start');
    this.queue = [];
    if (this.draftData.myteam_id != null && this.draftData.myteam_id > 0) {
      this._draftService.getQueueData(this.draftData.myteam_id).subscribe(res => {
        // console.log('getQueueData service');
        res.arrayBuffer().then(buffer => {
          if (buffer.byteLength > 1) {
            // reconstruct int32array
            const N = buffer.byteLength / 4;
            const queueArr = new Int32Array(buffer, 0, N);
            // console.log('getQueueData N: ' + N);
            for (let index = 0; index < N; index++) {
              this.queue.push(queueArr[index]);
            }
          }
          // console.log('call getQueuePlayers');
          this.getQueuePlayers();
          // console.log('call getTablePlayers');
          this.getTablePlayers();
        });
      });
    }
  }

  getTablePlayers(isFilter = null) {
    // console.log('getTablePlayers start');
    // fill table players
    this.tablePlayers = Object.keys(this.players).reduce((obj, key) => {
      obj.push(this.players[key]);
      return obj;
    }, []);
    // console.log('first step', this.tablePlayers);
    // sort table players
    if (this.tableSort != null) {
      this.tablePlayers.sort((a, b) => {
        if (a[this.tableSort] == null || b[this.tableSort] == null) return 0;
        if (this.tableSort == 'adp') {
          // give 0 opposite priority in ADP
          if (a[this.tableSort] == 0 && this.tableSortOrder == -1) return -1 * this.tableSortOrder;
          if (b[this.tableSort] == 0 && this.tableSortOrder == -1) return 1 * this.tableSortOrder;
          if (isNaN(parseFloat(a[this.tableSort]))) {
            return a[this.tableSort] > b[this.tableSort] ? -1 * this.tableSortOrder : 1 * this.tableSortOrder;
          } else {
            return parseFloat(a[this.tableSort]) > parseFloat(b[this.tableSort]) ? -1 * this.tableSortOrder : 1 * this.tableSortOrder;
          }
        }
        if (this.tableSort == 'fn') {
          return a[this.tableSort] > b[this.tableSort] ? -1 * this.tableSortOrder : 1 * this.tableSortOrder;
        }
        if (this.tableSort == 'order') {
          return a[this.tableSort] > b[this.tableSort] ? -1 * this.tableSortOrder : 1 * this.tableSortOrder;
        }
        if (isNaN(parseFloat(a[this.tableSort]))) {
          return a[this.tableSort] > b[this.tableSort] ? 1 * this.tableSortOrder : -1 * this.tableSortOrder;
        } else {
          return parseFloat(a[this.tableSort]) > parseFloat(b[this.tableSort]) ? 1 * this.tableSortOrder : -1 * this.tableSortOrder;
        }
      });
    }

    // team filter
    if (this.teamFilter != null && this.teamFilter != 'ALL') {
      // console.log(this.tablePlayers, this.teamFilter);
      this.tablePlayers = this.tablePlayers.filter(p => p.tn.toUpperCase() == this.teamFilter);
    }

    // console.log('second step', this.tablePlayers);

    if (this.search == '') {
      // remove picked players when not searching
      this.tablePlayers = this.tablePlayers.filter(tp => {
        return tp.own == null || tp.own != 'yes';
      });
      // console.log('picked players', this.tablePlayers);

      // if not searching, we should filter out full positions/unselected positions
      let validPos = [];
      const posDict = this.draftData.roster_position.reduce((acc, rp) => {
        if (rp.id != null || rp.pname == 'Hitters') acc[rp.pname] = rp.composed_of.split(',');
        return acc;
      }, {});
      // console.log(posDict, this.selectedFilters);
      this.selectedFilters.forEach(pos => {
        if (posDict[pos] != null) {
          validPos = validPos.concat(posDict[pos]);
        }
      });
      // console.log(validPos);
      this.tablePlayers = this.tablePlayers.filter(player => {
        const positions = player.pn.split(',');
        let isValid = false;
        positions.forEach(p => {
          if (this.draftData.position_removed.indexOf(p) == -1 && validPos.indexOf(p) > -1) isValid = true;
        });
        return isValid;
      });

    } else {
      // return matching search players
      const regex = new RegExp(this.search, 'gi');
      this.tablePlayers = this.tablePlayers.filter(player => {
        if (player.fn == null || player.ln == null) return false;
        return (player.fn.match(regex) != null || player.ln.match(regex) != null || String(player.fn + ' ' + player.ln).match(regex) != null);
      });
      // console.log('search', this.tablePlayers);
    }

    // empty players table if draft completed or invalid lgm
    if (this.pickInfoBox.status == 4 || this.draftData.myteam_id == null || this.draftData.myteam_id == 0) this.tablePlayers = [];

    //chunk LAST
    // show 50 players at a time
    // console.log('chunking');
    this.tablePlayers = this.tablePlayers.filter((p, i) => i >= this.topIndex && i < this.topIndex + 100);
    if (this.search == '' && isFilter == null && !this.tablePlayers.length && this.pickInfoBox.status == 3) {
      this.setFilters({ pname: 'All' });
    }
    this.tablePlayers.forEach(p => {
      if (p.it == null) p.it = '';
    });
    // console.log(this.tablePlayers);
  }

  setHeaderLinks(ent) {
    const team_slug = (ent.myteam_id != null && ent.myteam_id > 0) ? ent.lgm.filter(lgm => lgm.team_id == ent.myteam_id)[0].team_slug : null;
    this.leagueURL = this.league.tournament_id > 0 ?
      `${environment.SITE_URL}/tournament/${this.league.lg_abbr}/${this.league.tournament_code}` :
      `${environment.SITE_URL}/league/profile/${this.league.lg_abbr}/${this.league.league_code}`;
    this.myTeamURL = (team_slug != null) ? (this.league.tournament_id > 0 ?
      `${environment.SITE_URL}/tournament/my-team/${this.league.tournament_code}/${this.user.id}` :
      `${environment.SITE_URL}/manage-league/my-team/${this.league.league_code}/${team_slug}`) :
      ('');
    this.matchupURL = this.league.tournament_id > 0 ?
      '' :
      `${environment.SITE_URL}/league/matchup/${this.league.lg_abbr}/${this.league.league_code}`;
    this.playersURL = this.league.tournament_id > 0 ?
      `${environment.SITE_URL}/tournament/players/${this.league.tournament_code}` :
      `${environment.SITE_URL}/manage-league/players/${this.league.league_code}`;
    this.draftURL = '/draft/' + this.league_id;
    this.settingsURL = this.league.tournament_id > 0 ?
      `${environment.SITE_URL}/tournament/settings/${this.league.lg_abbr}/${this.league.tournament_code}` :
      `${environment.SITE_URL}/league/settings/${this.league.lg_abbr}/${this.league.league_code}`;
  }

  isVisible(slide, container) {
    const index = slide.total_pick - 1;
    const slideW = 81;
    const w = container.clientWidth;
    const leftIndex = Math.floor(container.scrollLeft / slideW);
    const rightIndex = Math.ceil((container.scrollLeft + w) / slideW);
    return index >= leftIndex && index < rightIndex;
  }

  pRowVisible(index, container,type) {
    const rowH = type=='player'?51:41;
    const topIndex = Math.floor(container.scrollTop / rowH);
    const bottomIndex = Math.ceil((container.scrollTop + container.clientHeight) / rowH);
    return index >= topIndex && index < bottomIndex;
  }

  activeDraftCount(isActiveDraft: boolean) {
    if (isActiveDraft) {
      this.isActiveDraft = true;
    } else {
      this.isActiveDraft = false;
    }
  }

  updateSliderScroll(event) {
    this.sliderScroll = event.target.scrollLeft;
  }

  updatePScroll(event) {
    this.pScroll = event.target.scrollTop;
    // update this.topIndex here based on scrollTop and scrollHeight
    // if inside the bounds of a topIndex update, need to call getTablePlayers()
    if (!this.scrollUpdating) {
      if (this.pScroll < 5 && this.topIndex > 0) {
        this.scrollUpdating = true;
        this.topIndex -= 50;
        this.getTablePlayers();
        event.target.scrollTop = 50 * 41;
        setTimeout(() => {
          if (event.target.scrollTop == 0 || event.target.scrollTop >= event.target.scrollHeight - event.target.clientHeight - 5)
            event.target.scrollTop = 50 * 41;
        }, 1);
        setTimeout(() => {
          this.scrollUpdating = false;
        }, 500);
      } else if (this.pScroll >= event.target.scrollHeight - event.target.clientHeight - 5) {
        if (this.tablePlayers.length == 100) {
          this.scrollUpdating = true;
          this.topIndex += 50;
          this.getTablePlayers();
          setTimeout(() => {
            if (event.target.scrollTop == 0 || event.target.scrollTop >= event.target.scrollHeight - event.target.clientHeight - 5)
              event.target.scrollTop = 50 * 41 - event.target.clientHeight;
          }, 1);
          setTimeout(() => {
            this.scrollUpdating = false;
          }, 500);
        }
      }
    }
  }

  updateQScroll(event) {
    this.qScroll = event.target.scrollTop;
  }

  startTimer() {
    if (this.pickInfoBox != null) {
      clearInterval(this.timeleftTimer);
      this.timeleftTimer = setInterval(() => {
        if (this.pickInfoBox != null) {
          this.timeleft = Math.round(this.pickInfoBox.timestamp + this.delta - Date.now() / 1000);
          if (this.timeleft > 0 && this.pickInfoBox.auto_pause != 1) {
            this.timeleft--;
          } else {
            clearInterval(this.timeleftTimer);
          }
        }
      }, 1000);
    }
  }

  // /////////////////////////////////////////////////
  // /////////////////////////////////////////////////
  // Helper Functions
  //
  //

  formatPickClock(sec) {
    if (sec >= 60 * 60 * 24) {
      // days
      return Math.floor(sec / (60 * 60 * 24)) + " day";
    } else if (sec >= 60 * 60) {
      // hours
      return Math.floor(sec / (60 * 60)) + " hr";
    } else if (sec >= 60) {
      // minutes
      return Math.floor(sec / 60) + " min";
    } else {
      // seconds
      return sec + " sec";
    }
  }

  getScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }

  getRGBAColor(color) {
    return 'rgba(' + parseInt('0x' + color.substr(1, 2), 16) + ',' + parseInt('0x' + color.substr(3, 2), 16) + ',' + parseInt('0x' + color.substr(5, 2), 16) + ',' + color.substr(8) + ')';
  }

  setFilters(rp) {
    // console.log(rp);
    this.topIndex = 0;
    this.playersTable.nativeElement.scrollTop = 0;
    if (rp.pname == 'All') {
      this.selectedFilters = this.draftData.roster_position.reduce((obj, elm) => {
        obj.push(elm.pname);
        return obj;
      }, []);
    } else {
      // if (this.selectedFilters.indexOf(rp.pname) > -1) {
      //   if ((this.selectedFilters.length <= 2 && this.selectedFilters.indexOf('All') > -1) || (this.selectedFilters.length == 1 && this.selectedFilters.indexOf('All') == -1)) {
      //     // turn on all if turning off all
      //     this.selectedFilters = this.draftData.roster_position.reduce((obj, elm) => {
      //       obj.push(elm.pname);
      //       return obj;
      //     }, []);
      //   } else if (this.selectedFilters.length == this.draftData.roster_position.length) {
      //     // if all activated, only activate selected position
      //     this.selectedFilters = [rp.pname];
      //   } else {
      //     // regular removal
      //     this.selectedFilters.splice(this.selectedFilters.indexOf(rp.pname), 1);
      //   }
      // } else {
      //   // regular addition
      //   this.selectedFilters.push(rp.pname);
      // }

      // Single position toggle, uncomment above section for multiple position toggle
      if (this.selectedFilters.length == 1 && this.selectedFilters[0] == rp.pname) {
        this.setFilters({ pname: 'All' });
      } else {
        this.selectedFilters = [rp.pname];
      }
      // end single position toggle, comment above out if you switch to multiple position
    }
    this.getTablePlayers(true);
  }

  getStyle(pname) {
    if (this.selectedFilters.indexOf(pname) == 0) {
      return this.filterStyles[pname];
    } else {
      return this.filterStyles[pname + '-off'];
    }
  }

  getPlayersHeight(elm) {
    if (!this.isMobile) {
      return (window.innerHeight - elm.getBoundingClientRect().top - 10);
    } else {
      return (window.innerHeight - elm.getBoundingClientRect().top - 60);
    }
  }

  getQueuePlayers(debug = false) {
    this.queuePlayers = [];
    this.queue.forEach(id => {
      if (debug) console.log(this.players[id]);
      const isOwn = (this.players[id] != null && this.players[id].own != null && this.players[id].own == 'yes');
      if (!isOwn) this.queuePlayers.push(this.players[id]);
    });

    this.queuePlayers = this.queuePlayers.filter(player => {
      const positions = player.pn.split(',');
      let isValid = false;
      positions.forEach(p => {
        if (this.draftData.position_removed.indexOf(p) == -1) isValid = true;
      });
      return isValid;
    });

    this.queuePlayers.forEach(p => {
      if (p.it == null) p.it = '';
    });

    // draft completed or invalid lgm, empty queue table
    if (this.pickInfoBox.status == 4 || this.draftData.myteam_id == null || this.draftData.myteam_id == 0) this.queuePlayers = [];
    if (debug) console.log(this.queue, this.queuePlayers);
  }

  addToQueue(player) {
    if (this.queue.indexOf(player.id) == -1) {
      this.queue.push(player.id);
      this._draftService.addToQueue(this.draftData.myteam_id, player.id).subscribe(res => {
        // console.log(res);
      });
    } else {
      this.queue.splice(this.queue.indexOf(player.id), 1);
      this._draftService.removeFromQueue(this.draftData.myteam_id, player.id).subscribe(res => {
        // console.log(res);
      });
    }
    this.getQueuePlayers();
  }

  getSchedule(player) {
    let result = '';
    if (player.tml == 'home') {
     // result += 'vs.';
    } else {
      result += '@';
    }
    result += player.opn.toUpperCase();
    return result;
  }

  getNameWidth(name) {
    const w = window.innerWidth;
    if (w > 400) {
      return '16px';
    } else if (name.length > 14) {
      return '12px';
    } else if (name.length > 10) {
      return '14px';
    } else {
      return '16px';
    }
  }

  getPickBar(slide) {
    if (this.currentPick > slide.total_pick) {
      return slide.player;
    } else if (this.pickInfoBox.is_active == 1) {
      return 'Your Pick!';
    } else {
      return 'Picking';
    }
  }

  getLeagueStatus() {
    if (this.pickInfoBox == null) return '';
    switch (this.pickInfoBox.status) {
      case 1:
        return 'Registering';
        break;
      case 2:
        return 'Pre-Draft';
        break;
      case 3:
        return 'Drafting';
        break;
      case 4:
        return 'Draft Complete';
        break;
      case 5:
        return 'Paused';
        break;
      default:
        return 'Draft Complete';
        break;
    };
  }

  myPlayersCount() {
    return this.slider.reduce((acc, item) => {
      if (item.lgm_id == this.draftData.myteam_id && item.player != null) acc++;
      return acc;
    }, 0);
  }

  disableAutoPick() {
    // if (this.league.duration_id != 8 && this.pickInfoBox.status != 5) this.isMessage = 'close';
    this.isAutoPick = false;
    this._resultboardService.disableAutoPick(this.league.id, this.draftData.myteam_id);
  }

  enableAutoPick() {
   this.isAutoPick = true;
    this.isMessage = 'open';
    this._resultboardService.enableManualAutoPick(this.league_id, this.draftData.myteam_id);
  }

  searchDelay() {
    clearInterval(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.getTablePlayers();
    }, 800);
  }

  clearSearch() {
    this.search = '';
    this.getTablePlayers();
  }
  clearFilter() {
    this.teamFilter = null;
    this.getTablePlayers();
  }

  tabChange(event) {
    if (!this.isMobile) {
      if (event.index == 2) {
        // chat tab
        this.unreadMessages = 0;
      } else if (event.index == 0) {
        // roster tab
        if(this.draftData)
        this.getShowRoster(this.draftData.lgm[this.rosterTabIndex].team_id, true);
      } else if (event.index == 3) {
        // info tab
        if (this.infoTab == null || this.scoringTab == null) {
          this.getInfoTab();
        }
      }
      // else if (event.index == 3){
      //   // table view
      //   this.getPickOrder();
      // }
    } else {
      if (event.index == 2) {
        // chat tab
        this.unreadMessages = 0;
      } else if (event.index == 3) {
        // roster tab
        this.getShowRoster(this.draftData.lgm[this.rosterTabIndex].team_id, true);
      } else if (event.index == 4) {
        // info tab
        if (this.infoTab == null || this.scoringTab == null) {
          this.getInfoTab();
        }
      }
    }
  }

  getModalState(modal) {
    if (this.isMobile) {
      if (modal == 0) {
        return (this.showModal) ? 'openMobile' : 'closeMobile';
      } else {
        return (this.showRankings) ? 'openMobile' : 'closeMobile';
      }
    } else {
      if (modal == 0) {
        return (this.showModal) ? 'openDesktop' : 'closeDesktop';
      } else {
        return (this.showRankings) ? 'openDesktop' : 'closeDesktop';
      }
    }
  }

  getShowRoster(lgm_id, hideModal = false,changeRoster=true) {
    if(this.pickInfoBox.status == 4 && this.showModal==true) return false;
    // if(changeRoster==false) return;
    this.current_lgm_id = lgm_id;
    this.showRoster = {};
    const slides = this.slider.filter(slide => slide.lgm_id == lgm_id);
    // console.log(slides);
    this.showRosterOwner = this.draftData.lgm.filter(lm => lm.team_id == lgm_id)[0];
    // this.showRosterOwner = slides[0].team_name;
    slides.forEach(slide => {
      let pos = this.draftData.roster_position.filter(rp => {
        return (rp.id != null && slide.p_pos != null && slide.player != null && rp.id == slide.p_pos);
      });
      if (pos.length) {
        slide.pname = pos[0].pname;
        slide.profile_image_uri = slide.player_picture.replace(`${environment.assetURL}/`,'');
        slide.order_id = pos[0].order_id;
        pos = pos[0].display_name;
        if (this.showRoster[pos] == null) {
          this.showRoster[pos] = [];
        }
        this.showRoster[pos].push(slide);
      }
    });
    
    this.draftData.roster_position.forEach((rp,ii) => {
      if(rp.pname!='All'){
        rp.pick_remain = rp.tpick;
        rp.isprinted = false;
        Object.values(this.showRoster).forEach(function (el2) {
          Object.values(el2).forEach((v,i)=>{
            if(v.pname==rp.pname){
              rp.isprinted= true;
               rp.pick_remain = --rp.pick_remain;
              }
          })
        });
      }      
    });
    if (Object.keys(this.showRoster).length) {
      Object.keys(this.showRoster).forEach(key => {
        this.showRoster[key].sort((a, b) => {
          return (a.total_pick > b.total_pick) ? 1 : -1;
        });
      });
      if(hideModal==false && this.pickInfoBox.status == 4 && (this.pickInfoBox.message=='Draft Completed')){
        this.showCamIcon = false;
        this.showLoadingBorder = true;
        this.getURL();
        this.getDraftSummry(this.draftData.myteam_id);
      }
      if (!hideModal) this.showModal = true;
    } else {
      this.showModal = false;
    }
    this.getDraftSummry();
  }
  getDraftSummry(lgm_id=null) {
    let openModel= lgm_id?true:false;
    this.showRosterNew = {};
    const currentUserFilled = {};
    if(lgm_id)
        this.currentinfoid = lgm_id;
    else if(this.currentinfoid)
        lgm_id =this.currentinfoid;
    else
        return false;
    
    const slides = this.slider.filter(slide => slide.lgm_id == lgm_id);
   this.showRosterOwner = this.draftData.lgm.filter(lm => lm.team_id == lgm_id)[0];
    slides.forEach(slide => {
      let pos = this.draftData.roster_position.filter(rp => {
        return (rp.id != null && slide.p_pos != null && slide.player != null && rp.id == slide.p_pos);
      });
      if (pos.length) {
        slide.pname = pos[0].pname;
        slide.profile_image_uri = slide.player_picture.replace(`${environment.assetURL}/`,'');
        slide.order_id = pos[0].order_id;
        pos = pos[0].display_name;
        if (this.showRosterNew[pos] == null) {
          this.showRosterNew[pos] = [];
        }
        this.showRosterNew[pos].push(slide);
      }
      if (currentUserFilled[slide.p_pos] != null) {
        currentUserFilled[slide.p_pos]++;
      } else {
        currentUserFilled[slide.p_pos] = 1;
      }
    });
    
    this.draftData.roster_position.forEach((rp,ii) => {
      if(rp.pname!='All'){
        rp.pick_remain = rp.tpick;
        rp.isprinted = false;
        Object.values(this.showRosterNew).forEach(function (el2) {
          Object.values(el2).forEach((v,i)=>{
            if(v.pname==rp.pname){
              rp.isprinted= true;
               rp.pick_remain = --rp.pick_remain;
              }
          })
        });
      }      
    });
    if (Object.keys(this.showRosterNew).length) {
      Object.keys(this.showRosterNew).forEach(key => {
        this.showRosterNew[key].sort((a, b) => {
          return (a.total_pick > b.total_pick) ? 1 : -1;
        });
      });
     }
     
     this.hoverRosterPopup = this.draftData.roster_position.reduce((acc2, e) => {
       if (e.id != null) {
        acc2.push({
           position: e.pname,
           bgcolor: this.getRGBAColor(e.color_code),
           filled: (currentUserFilled[e.id] != null) ? currentUserFilled[e.id] : 0,
           total: e.tpick
         });
       }
       return acc2;
     }, []);

     if(openModel){
        if (Object.keys(this.showRosterNew).length) {
          this.showModal = true;
          if(this.pickInfoBox.status == 4){
            this.showCamIcon = false;
            this.showLoadingBorder = true;
            this.getURL();
          }
        }
      }
     
  }

  orderKeys = (a, b) => {
    if(this.league != null && a.value[0].order_id != null) return a.value[0].order_id > b.value[0].order_id ? 1 : -1; /**Sort by DB order id */
    else if(this.league != null && this.league.game_id == 1) return b.value[0].p_pos > a.value[0].p_pos ? 1 : -1;
    else return a.value[0].p_pos > b.value[0].p_pos ? 1 : -1;
  }

  rtIndexChange(increment) {
    if (increment=='custom') {
    } else if (increment) {
      if (this.rosterTabIndex < this.draftData.lgm.length - 1) {
        this.rosterTabIndex++;
      } else {
        this.rosterTabIndex = 0;
      }
    } else {
      if (this.rosterTabIndex > 0) {
        this.rosterTabIndex--;
      } else {
        this.rosterTabIndex = this.draftData.lgm.length - 1;
      }
    }
    this.getShowRoster(this.draftData.lgm[this.rosterTabIndex].team_id, true);
  }

  getInfoTab() {
    const sub = this._resultboardService.getInfoTabs(this.league.tournament_id, this.league.id, this.user.id, 'info').subscribe(res => {
      if (res.status == 'success') this.infoTab = res.entities;
      const sub2 = this._resultboardService.getInfoTabs(this.league.tournament_id, this.league.id, this.user.id, 'scoring').subscribe(res2 => {
        // res == info tab, res2 == scoring tab
        if (res2.status == 'success') this.scoringTab = res2.entities;
        // console.log(this.infoTab,this.scoringTab);
        sub2.unsubscribe();
      });
      sub.unsubscribe();
    });
  }

  updateCPick() {
    const myPicks = this.slider.filter(s => (s.lgm_id == this.draftData.myteam_id && s.p_pos != null));
    const cPicks = {};
    myPicks.forEach(p => {
      if (cPicks[p.p_pos] == null) {
        cPicks[p.p_pos] = 1;
      } else {
        cPicks[p.p_pos]++;
      }
    });
    this.draftData.roster_position.forEach(rp => {
      if (cPicks[rp.id] != null) rp.cpick = cPicks[rp.id];
    });
  }

  getPickOrder() {
    const temp = [];
    // this.pickOrder = [];
    this.slider.forEach(s => {
      if (temp[s.round - 1] == null) {
        temp[s.round - 1] = [s];
      } else {
        temp[s.round - 1].push(s);
      }
    });
    // snake display
    temp.forEach((round, i) => {
      if (i % 2) round.reverse();
    });
    this.pickOrder = temp;
    // console.log('getPickOrder', this.pickOrder);
  }

  getPosition(id) {
    const res = this.draftData.roster_position.filter(rp => rp.id == id);
    if (res.length) {
      return res[0].pname;
    } else {
      return '';
    }
  }
  getAutoPickStatus(){
    return !this.isAutoPick;
  }
  autoCheckbox(checkbox) {
    this.isAutoPick = !checkbox.checked;
    if (!checkbox.disabled) {
      if (!this.isAutoPick) {
        this.enableAutoPick();
      } else {
        this.disableAutoPick();
      }
    }
  }

  removeAllPositions() {
    this.draftData.roster_position.forEach(rp => {
      if (rp.id != null && this.roster_removed.indexOf(rp.pname) == -1) {
        this.roster_removed.push(rp.pname);
      }
    });
  }

  getImportList() {
    if (this.pickInfoBox.status != 4) {
      this.rankingSets = [];
      this.showLoading = true;
      this._resultboardService.getRankingSets(this.league.game_id, this.league.egs, this.league.lgs, this.user.id, this.league.id).subscribe(res => {
        this.showLoading = false;
        if (res.status == 'success' && res.entities.length) {
          this.rankingSets = res.entities;
          this.showRankings = true;
        } else {
          // display no ranking sets message
          this.openSnackBar('No ranking sets to import', 'OK');
        }
      });
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  importSet(id) { 
    this.showRankings = false;
    this.showLoading = true;
    this._resultboardService.importRankings(this.league.id, this.draftData.myteam_id, id, this.user.id).subscribe(res => {
      // console.log(res);
      this.getPlayerPool(true);
      this.common_rank_id = id;
      this.showLoading = false;
    });
  }

  setRosterRemoved() {
    this.roster_removed = [];
    this.draftData.roster_position.forEach(rp => {
      if (rp.id != null && rp.cpick >= rp.tpick) {
        if (this.league.duration_id == 8) {
          // best ball logic
          const details = this.draftData.roster_position.reduce((acc, r) => {
            if (r.id != null) {
              acc.drafted += r.cpick;
              if (r.tpick > r.cpick) {
                acc.needed += r.tpick - r.cpick;
              }
            }
            return acc;
          }, {
            needed: 0,
            drafted: 0
          });
          // console.log('details',details,'total_players',this.league.total_players);
          if (details.needed >= this.league.total_players - details.drafted) {
            this.roster_removed.push(rp.pname);
          }
        } else {
          this.roster_removed.push(rp.pname);
        }
      }
      if (rp.pname == 'All') {
        rp.cpick = this.draftData.roster_position.reduce((acc, r) => {
          if (r.pname != 'All') acc += r.cpick;
          return acc;
        }, 0);
      }
    });
  }

  isEmptyObject(obj) {
    return (Object.keys(obj).length > 0) ? false : true;
  }

  getTableHeaderWidth(tContainer, tableContainer) {
    if (tContainer.scrollWidth > tableContainer.clientWidth) {
      return tContainer.scrollWidth + 'px';
    } else {
      return '100%';
    }
  }

  unsubSockets() {
    if (this.s_disconnect) this.s_disconnect.unsubscribe();
    if (this.s_pong) this.s_pong.unsubscribe();
    if (this.s_refreshPage) this.s_refreshPage.unsubscribe();
    if (this.s_isMobileScreen) this.s_isMobileScreen.unsubscribe();
    if (this.s_initListener) this.s_initListener.unsubscribe();
    if (this.s_navigation) this.s_navigation.unsubscribe();
    if (this.s_activeDraft) this.s_activeDraft.unsubscribe();
    if (this.s_listActiveDraft) this.s_listActiveDraft.unsubscribe();
    if (this.s_pickChanges) this.s_pickChanges.unsubscribe();
    if (this.s_pickTime) this.s_pickTime.unsubscribe();
    if (this.s_pickedPlayer) this.s_pickedPlayer.unsubscribe();
    if (this.s_draftCompleted) this.s_draftCompleted.unsubscribe();
    if (this.s_showDraft) this.s_showDraft.unsubscribe();
    if (this.s_draftReset) this.s_draftReset.unsubscribe();
    if (this.s_leaguePost) this.s_leaguePost.unsubscribe();
    if (this.s_pausedMessage) this.s_pausedMessage.unsubscribe();
    if (this.s_resumeMessage) this.s_resumeMessage.unsubscribe();
    if (this.s_readybox) this.s_readybox.unsubscribe();
    if (this.s_reversePick) this.s_reversePick.unsubscribe();
    this.leaveRoom();
  }

  checkMissedPicks(pnum) {
    const results = this.slider.filter(s => s.total_pick < pnum && s.player == null);
    // if (results.length) console.log('MISSED PICK!!!', pnum, results);
    if (results.length) {
      this.openSnackBar('Data Desynchronized, Refreshing...', 'OK');
      setTimeout(() => {
        if(this.reloadConfirmDialogRef)
        this.reloadConfirmDialogRef.close();
        this.reloadConfirmDialogRef = this.dialog.open(ConfirmboxComponent, {
            width: '500px',
            data: { 'title': "Refresh Page Alert",'body': 'Data Desynchronized. Please refresh the page.'}
        });
      this.reloadConfirmDialogRef.afterClosed().subscribe(res => {
        document.location.reload();
      }); 
      }, 2000);
    }
  }

  getBye(id) {
    return (this.players != null && this.players[id] != null && this.players[id].bye != null) ? this.players[id].bye : 0;
  }
  
  getAdp(id) {
    return (this.players != null && this.players[id] != null && this.players[id].adp != null) ? this.players[id].adp : 0;
  }

  prettyPrint(number) {
    const rem = number % 100;
    if (rem > 10 && rem < 21) {
      // awkward teens :p
      return number + 'th';
    } else {
      const rem2 = number % 10;
      if (rem2 == 1) return number + 'st';
      if (rem2 == 2) return number + 'nd';
      if (rem2 == 3) return number + 'rd';
      return number + 'th';
    }
  }

  changeView() {
    this.currentView = (this.currentView == 'table') ? 'slider' : 'table';
    setTimeout(() => {
      if (this.pickInfoBox.status == 3 || this.pickInfoBox.status == 5) {
        // slide to current pick far right, or just 0
        if (this.currentView == 'slider') {
          const sliderRef = this.sliderContainer.nativeElement as HTMLElement;
          sliderRef.scrollLeft = ((this.currentPick - Math.floor(sliderRef.clientWidth / 95) > 0) ? (this.currentPick - Math.floor(sliderRef.clientWidth / 95)) * 95 - 1 : 0);
        } else {
          const tRef = this.tContainer.nativeElement as HTMLElement;
          if(!this.showResetIcon){
            tRef.scrollTop = ((Math.floor((this.currentPick - 1) / this.draftData.lgm.length) - 5) * 40);
            setTimeout(()=>{
              this.showResetIcon = false;
            },800);
          }
          if (tRef.scrollWidth > tRef.clientWidth) {
            tRef.scrollLeft = (Math.floor((this.currentPick - 1) / this.draftData.lgm.length) % 2) ? 30 + ((this.draftData.lgm.length - ((this.currentPick - 1) % this.draftData.lgm.length)) - 3) * 95 : 30 + ((((this.currentPick - 1) % this.draftData.lgm.length) - 2) * 95);
          }
        }
        if(this.currentView=='table'){
          setTimeout(()=>{
             this.resetTableRowsView();
          })
        }
       
      }
    }, 500);
  }

  availRoster(pos) {
    // roster_removed.indexOf(rp.pname) > -1
    let basePos = [];
    this.draftData.roster_position.forEach(rp => {
      if (this.roster_removed.indexOf(rp.pname) == -1) {
        basePos = [...basePos, ...rp.composed_of.split(',')];
      }
    });
    basePos = basePos.reduce((acc, c) => {
      if (acc.indexOf(c) == -1) acc.push(c);
      return acc;
    }, []);
    return (this.roster_removed.indexOf(pos) == -1 || basePos.indexOf(pos) > -1);
  }

  updateHoverStyle(element, lgm_id, event) {
    event.stopPropagation();
    event.preventDefault();
    this.getHoverRoster(lgm_id);
    const pos = element.getBoundingClientRect();
    this.hoverStyle.top = Math.round(pos.top + element.clientHeight) + 'px';
    this.hoverStyle.left = Math.round(pos.left) + 'px';
    this.hoverStyle.width = element.clientWidth + 'px';
    this.hoverStyle.display = 'block';
  }

  getHoverRoster(lgm_id) {
    if (!lgm_id) return;
    const userFilled = {};
    const userPicks = this.slider.filter(s => s.lgm_id == lgm_id);
    userPicks.forEach(p => {
      if (userFilled[p.p_pos] != null) {
        userFilled[p.p_pos]++;
      } else {
        userFilled[p.p_pos] = 1;
      }
    });
    this.hoverRoster = this.draftData.roster_position.reduce((acc, e) => {
      if (e.id != null) {
        acc.push({
          position: e.pname,
          bgcolor: this.getRGBAColor(e.color_code),
          filled: (userFilled[e.id] != null) ? userFilled[e.id] : 0,
          total: e.tpick
        });
      }
      return acc;
    }, []);
    this.getRosterData[lgm_id] = this.hoverRoster; 
  }

  queueDrop(oldIndex, newIndex) {
    const player = this.queuePlayers[newIndex];
    if (player != null && (this.players[player.id].own == null || this.players[player.id].own !== 'yes')) {
      let insertBefore = null;
      let isLast = false;
      let isFirst = false;
      if (newIndex == 0) {
        isFirst = true;
      } else if (newIndex == this.queuePlayers.length - 1) {
        isLast = true;
      } else {
        const nextPlayer = this.queuePlayers[newIndex + 1];
        insertBefore = nextPlayer.id;
      }
      // splice local queue
      this.queue.splice(this.queue.indexOf(player.id), 1);
      if (isFirst) {
        this.queue.unshift(player.id);
      } else if (isLast) {
        this.queue.push(player.id);
      } else {
        this.queue.splice(this.queue.indexOf(insertBefore), 0, player.id);
      }
      // use isFirst, isLast, and insertBefore to send to server and update queue
      this._draftService.adjustQueue(this.draftData.myteam_id, isFirst, isLast, insertBefore, player.id).subscribe(res => {
        // sort queue again, in case picks have been made in the interim
        this.getQueuePlayers();
      });
    } else {
      // player is already picked, do something here
      if (player != null && player.id != null) {
        this.queue.splice(this.queue.indexOf(player.id), 1);
        this.queuePlayers.splice(newIndex, 1);
      }
      this.getQueuePlayers();
    }
  }

  changeTableFilter(value) {
    if (value == this.tableSort) {
      this.tableSortOrder = (this.tableSortOrder == 1) ? -1 : 1;
    } else {
      this.tableSort = value;
    }
    if (value == 'order') this.tableSortOrder = -1;
    this.getTablePlayers();
  }

  changeTableRows(inc = true) {
    this.showResetIcon = true;
    if (inc) {
      if (this.tableNumRows < this.league_rounds) this.tableNumRows++;
    } else {
      if (this.tableNumRows > 1) this.tableNumRows--;
    }
    this.tableCHeight = (this.tableCHeight == 'none') ? 'none' : `${this.tableHeaderHeight + (this.tableNumRows * 38)}px`;
  }
  resetTableRowsView() {
    if(this.currentView=='table'){
      let cr =Math.ceil(this.currentPick / this.draftData.lgm.length);
      const tRef = this.tContainer.nativeElement as HTMLElement;   
      if(this.tableNumRows + (cr-6)>this.league_rounds){
        setTimeout(()=>{
          this.resetTableRowsView()
        },1000); 
      }
      setTimeout(()=>{
        this.showResetIcon = false;
      },200);    
      this.tableNumRows = 6;
      this.tableCHeight = (this.tableCHeight == 'none') ? 'none' : `${this.tableHeaderHeight + (this.tableNumRows * 38)}px`;
      tRef.scrollTop = ((Math.floor((this.currentPick - 1) / this.draftData.lgm.length) - 5) * 38);  
    }
  }
  resultrBoardScrollEvent(event){
    this.showResetIcon = true;
  }

  getPickMessage() {
    if (this.slider != null && this.slider[this.currentPick - 1] != null && this.draftData.myteam_id == this.slider[this.currentPick - 1].lgm_id) {
      // my pick!
      return 'Your Pick!';
    } else {
      // not my pick
      const next = this.slider.findIndex((e, i) => i > this.currentPick - 1 && e.lgm_id == this.draftData.myteam_id);
      if (next == -1) {
        return 'Draft Completed';
      } else {
        return `${next - (this.currentPick - 1)} ${next - (this.currentPick - 1) > 1 ? 'Picks' : 'Pick'} Away`;
      }
    }
  }

  getPickClock(timeleft) {
    if (timeleft > 60 * 60 * 24) {
      // days
      const days = Math.floor(timeleft / (60 * 60 * 24));
      return `${days} ${days > 1 ? 'days' : 'day'}`;
    } else if (timeleft > 60 * 60) {
      // hours
      const hours = Math.floor(timeleft / (60 * 60));
      const minutes = Math.floor(timeleft / 60) % 60;
      const seconds = timeleft % 60;
      return `${this.tp(hours)}:${this.tp(minutes)}:${this.tp(seconds)}`;
    } else {
      // minutes
      const minutes = Math.floor(timeleft / 60);
      const seconds = timeleft % 60;
      return `${this.tp(minutes)}:${this.tp(seconds)}`;
    }
  }

  tp(val) {
    return (val.toString().length == 1) ? `0${val}` : `${val}`;
  }

  getPositionColor(p) {
    // Check hashmap first
    if (this.positionColors[p] != null) {
      return this.positionColors[p];
    }
    // This only matches first instance of, no additional logic (base versus composed, etc.)
    const found = this.draftData.roster_position.find(rp => rp.composed_of.split(',').indexOf(p) > -1 && rp.pname != 'Hitters');
    if (!found){
      const found2 = this.draftData.roster_position.find(rp => rp.pname==p);
      if(!found2)
      return !this.darkMode?'#000':'#FFF'; 
      this.positionColors[p] = this.getRGBAColor(found2.color_code);
    } else{
      this.positionColors[p] = this.getRGBAColor(found.color_code);
    }
    return this.positionColors[p];
  }

  getInjuryAbbr(desc) {
    switch (desc) {
      case 'Out':
        return 'O';
      case 'Day-To-Day':
        return 'Q';
      case 'IR':
        return 'O';
      case 'IR-NR':
        return 'O';
      case 'IR-LT':
        return 'O';
      case 'QUESTIONABLE':
        return 'Q';
      case 'DOUBTFUL':
        return 'O';
      case 'OUT':
        return 'O';
      case 'INACTIVE':
        return 'O';
      case 'PUP-R':
        return 'O';
      case 'PUP-P':
        return 'O';
      case 'IR-R':
        return 'O';
      case 'IR':
        return 'O';
      case 'RESERVE-DNR':
        return 'O';
      case 'NFI-R':
        return 'O';
      case 'NFI-A':
        return 'O';
      case 'RESERVE-CEL':
        return 'O';
      case 'RESERVE-SUS':
        return 'O';
      case 'RESERVE-RET':
        return 'O';
      case 'RESERVE-EX':
        return 'O';
      case 'RESERVE-COVID-19':
        return 'O';
      case 'GTD':
        return 'D';
      case 'OUT':
        return 'O';
      case 'OFS':
        return 'O';
      case '60-Day IL':
        return 'O';
      case '15-Day IL':
        return 'O';
      case '10-Day IL':
        return 'O';
      case 'Out':
        return 'O';
      case '7-Day IL':
        return 'O';
      case 'Suspension':
        return 'O';
      case 'Paternity':
        return 'O';
      case 'Bereavement':
        return 'O';
      case 'COVID-19':
        return 'O';
      default:
        return desc.charAt(0);
    }
  }

  getPositions(pn) {
    return pn.split(',');
  }
  toggleDarkTheme(): void {
    this.darkMode = !this.darkMode;
    setTimeout(()=>{
    if(this.darkMode)
    document.body.classList.add('dark-theme');
    else
    document.body.classList.remove('dark-theme');
    },100);
    localStorage.setItem('darkMode',this.darkMode?'true':'false');
 }
  async downloadImage() {
    setTimeout(()=>{
            this.showCanvas =true;
              html2canvas(this.screen.nativeElement,{scale:3,allowTaint:true,useCORS: true, backgroundColor: this.darkMode?"#0E1523":"#f5f5f5" }).then(canvas => {
                this.downloadLink.nativeElement.href = canvas.toDataURL("image/png");
                this.canvas.nativeElement.src = canvas.toDataURL("image/png");
                this.downloadLink.nativeElement.download = "draft-summary-"+this.showRosterOwner.team_name+".png";
                this.downloadLink.nativeElement.click();
                this.showCanvas =false;
                setTimeout(()=>{
                  this.showCamIcon = true;
                },500)
              });
            },100)
  }
  async getURL(){
    this.showLoadingBorder = false;
    return true;
    let newImg = [];
    let request_left = 0;
    if(!this.allImgsArray.length){
      this.allImgsArray.push('assets/default/images/logo.png');
      this.allImgsArray.push('assets/default/images/logo-red.png');
      newImg.push('assets/default/images/logo.png');
      newImg.push('assets/default/images/logo-red.png');
    }
    if (Object.keys(this.showRosterNew).length) {
            Object.keys(this.showRosterNew).forEach(key => {
              this.showRosterNew[key].forEach((slide,key2)=>{
                let playerImgUrl = slide.player_picture.replace(`${environment.assetURL}/`,'')
                if(this.allImgsArray.indexOf(playerImgUrl)==-1){
                  this.allImgsArray.push(playerImgUrl);
                  newImg.push(playerImgUrl);
                }
              })
            });
          }
      const chunks = [];
        for (let i = 0; i < newImg.length; i += 5) {
            const chunk = newImg.slice(i, i + 5);
            chunks.push(chunk);
        }
        request_left = chunks.length;
       for (let k = 0; k < chunks.length; k++) {
          this._mainService.getImageData(chunks[k]).subscribe(res => {
            request_left--;
            Object.keys(res).forEach((a,v) => {
            if(!Object.keys(this.imageData).includes(a)){
              this.imageData[a]= res[a]
            }      
          })
        });
      }
    let timer = setInterval(() => {
        if (request_left <= 0){
          if(this.pickInfoBox.status==4)
          this.showCamIcon = true;
          this.showLoadingBorder = false;
          clearInterval(timer);
        }
      },1000);
      setTimeout(()=>{
        clearInterval(timer);
      },15000)
   }

   
   draftPlayer(player_id, playerList, isDraft, playerData) {         
    this.disableDraft=true;
        const data = {
          picker_id: String(this.draftData.myteam_id),
          league_id: String(this.league.id),
          player_id: String(player_id),
          player_name: playerData.fn + ' ' + playerData.ln,
          player_team: playerData.tn,
          player_position: playerData.pn,
          pick_number: Number(this.currentPick),
          plr_team_id: String(playerData.tid),
          profile_pic: playerData.pp,
          device: 'web',
          pickedFrom: 'swipe',
          filteredPosition:this.selectedFilters[0]
        };
        const sub = this._resultboardService.draftButtonEmit(data).subscribe(res => {
          sub.unsubscribe();
        });
    }

  breakPlayerName(fullName: string): string {
    const maxLength = 15;
    if (fullName.length <= maxLength) {
      return fullName;
    }
    const nameParts = fullName.split(' ');
    if (nameParts.length < 2) {
      return fullName;
    }
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(' ');
    const breakFirstName = firstName.charAt(0) + '.';
    const breakName = `${breakFirstName} ${lastName}`;
    return breakName;
  } 
}